import { useEffect } from 'react';
import HeroSection from '../components/Landing/HeroSection';
import CompanySection from '../components/Landing/CompanySection';
import SolutionSection from '../components/Landing/SolutionSection';
import BlogSection from '../components/Landing/BlogSection';
import NewsSection from '../components/Landing/NewsSection';
import ContactSection from '../components/Landing/ContactSection';
import PartnersSection from '../components/Landing/PartnersSection';
import TopButton from '../components/common/TopButton';

export default function LandingPage() {
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div>
      <HeroSection />
      <CompanySection />
      <SolutionSection />
      <PartnersSection />
      <BlogSection />
      <NewsSection />
      <ContactSection />
      <TopButton />
    </div>
  );
}
